import { render, staticRenderFns } from "./NewsHeader.vue?vue&type=template&id=6880e271&"
import script from "./NewsHeader.vue?vue&type=script&lang=js&"
export * from "./NewsHeader.vue?vue&type=script&lang=js&"
import style0 from "./NewsHeader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports